import React, { useState } from "react";
import { TextField, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

const TimePicker = ({
  fieldValues = {},
  field = {},
  values = {},
  onChange = () => {},
  ...props
}) => {
  const [time, setTime] = useState(values[field.key] ? values[field.key] : "00:00");

  const handleTimeChange = (newTime) => {
    if (newTime) {
      onChange(field, newTime);
      setTime(newTime);
    } else {
      setTime("00:00");
      onChange(field, "00:00");
    }
  };

  return (
    <TextField
      type="time"
      required={(field.visible && field.required) || false}
      error={props.fieldErrors[field.key] ? true : false}
      key={field.key}
      id={`textfield_${field.key}`}
      size="small"
      label={field.label}
      value={time ? time : "00:00"}
      hidden={!field.visible}
      helperText={
        props.fieldErrors[field.key] ? props.fieldErrors[field.key] : undefined
      }
      variant="outlined"
      onKeyDown={props.validate.bind(this, field)}
      disabled={field.disabled}
      className="mb-3"
      fullWidth
      onChange={(e) => handleTimeChange(e.target.value)}
      slotProps={{ inputLabel: { shrink: true }, input: {
        endAdornment: time && (
          <IconButton onClick={() => handleTimeChange("00:00")} size="small">
            <ClearIcon />
          </IconButton>
        ),
      } }}
    />
  );
};

export default TimePicker;
